import { render, staticRenderFns } from "./credit_payments.vue?vue&type=template&id=61848c3c&"
import script from "./credit_payments.vue?vue&type=script&lang=js&"
export * from "./credit_payments.vue?vue&type=script&lang=js&"
import style0 from "./credit_payments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports